const sendEvent = (data) => {
	if (!window || ! window.ga) {
		console.warn('No analytics', data)
		return
	}

	if (localStorage && localStorage.debug && (localStorage.debug === '*' || localStorage.debug === 'tracking')) {
		console.info('Sending analytics', data)
	}

	window.ga('send', {
	  hitType: 'event',
	  ...data
	})
}
export default sendEvent


// WEBPACK FOOTER //
// ./src/actions/events/sendEvent.js